var apiImport = null;

function setApiImport(imp) {
    apiImport = imp;
}

export { setApiImport, apiImport as impo };
